var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._b({style:(_vm.styles),attrs:{"src":"https://dev.teams.microsoft.com/hashed/e560eef2df218a593adcd028fb83a3e9.png"}},'img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }